module.exports = "<div class=\"kl-scroll-bar is-{direction}\" on-mousedown={this.clickTrackHandler($event)}>\n  <div class=\"kl-scroll-bar__thumb\" ref=\"thumb\"\n       thumbStyle\n       on-mousedown={this.clickThumbHandler($event)}></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ../src/js/components/widget/KLScroll/KLScrollBar/index.html
// module id = 540
// module chunks = 0